// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8b5fa741","198":"92e7dc7d","328":"8ab2e635","389":"b1fa08f1","453":"825386d9","655":"026c6aa6","845":"15d329ec","869":"6d22b01e","953":"0f79efe0"}[chunkId] + ".chunk.js";
};